/**
 * Gets 3P products that support a given filter, using ThirdPartyConfigs.
 *
 * This is intentionally in a separate file from filters/index.ts to avoid
 * pulling ThirdPartyConfigs (and its 66 icon-laden config files) into the
 * generateSearchInputs bundle. This file is only imported by UI filter
 * components, not by the generateSearchInputs call path.
 */
import type { FilterId as ConnectorsConfigFilterId } from '@atlassian/rovo-connectors-config/types/filters';

import { getThirdPartyConfigs } from '../../constants/3p-product-configs';
import type { FilterId } from '../../constants/filters';
import type { ProductKeys3P } from '../../constants/product-keys';

export const getProducts3PFromConfigForFilter = (filterId: FilterId): ProductKeys3P[] => {
	const productsForFilter: ProductKeys3P[] = [];
	getThirdPartyConfigs().forEach((config, productKey3P) => {
		// The search-page `FilterId` is a superset of the `rovo-connectors-config` `FilterId`
		// used by `config.filters`. If `filterId` is not one of the connector-supported filters
		// the `includes` check simply returns false, which is the desired behaviour.
		// Remove casting when cleaning up platform_search_3p_config_consolidation FG.
		if (config.filters?.includes(filterId as ConnectorsConfigFilterId)) {
			productsForFilter.push(productKey3P);
		}
	});
	return productsForFilter;
};
